import { Injectable } from '@angular/core';
import { DateTimeHelperService } from '@farris/ui-common/date';
import { NumberHelperService } from '@farris/ui-common/number';
import { DateUtil } from '@farris/devkit';

@Injectable()
class FarrisKendoGridFormatService {
    constructor(private dateService: DateTimeHelperService, private numberService: NumberHelperService) {
    }

    /**
     * åæ ¼å¼å æ¹æ³
     * @param dataItem  è¡æ°æ®
     * @param column åå¯¹è±¡
     */
    getColumnFormat(dataItem: any, column: any) {
        const value = this.getValue(dataItem, column['dataField']);
        // æ²¡æè®¾ç½®è¡ç¼è¾å¨
        const type = column['dataType'];
        if (type === 'enum') {
            return this.getEnumText(value, column);
        } else if (type === 'boolean') {
            return value ? 'æ¯' : 'å¦';
        } else if (type === 'date') {
            return this.getFormatDate(value, column);
        } else if (type === 'number') {
            return this.getFormatNumber(value, column);
        } else {
            // æ ¼å¼åå¤è¡ææ¬  åstring
            return this.getMultiText(value, column);
        }
    }

    /**
     * æ ¹æ®idè·åvalue
     * @param dataItem  è¡æ°æ®
     * @param field id,ä¹å¯è½æ¯name.Nameè¿ç§å½¢å¼(å³èå¯¹è±¡idæèudt)
     */
    private getValue(dataItem: any, field: string) {
        const index = field.indexOf('.');
        if (index < 0) {
            return dataItem[field];
        }
        const fields = field.split('.');
        // fieldå­ç¬¦ä¸²ç»å
        const a = fields.reduce((result: any, next: any) => {
            return result[next];
        }, dataItem);
        return a;
    }

    /**
     * æä¸¾å¼æ ¼å¼å
     */
    private getEnumText(value: any, column: any) {
        const enumData = (column as any).enumData;
        if (!enumData) {
            return;
        }
        let tempColumnText: any;
        enumData.forEach((ele: any) => {
            if (ele.value === value) {
                tempColumnText = ele.name;
            }
        });
        return tempColumnText;
    }

    /**
     * æ¥ææ ¼å¼å
     * @param value  ååæ ¼å¼
     * @param column åå¯¹è±¡
     */
    public getFormatDate(value: string, column: any): string {

        if (DateUtil.isEmptyDateString(value) === true) {
          return '';
        }

        const dateFormat = (column as any).format;
        if (!dateFormat) {
            return value;
        }
        return this.dateService.formatTo(value, dateFormat);
    }

    /**
     * æ°å­æ ¼å¼å
     * @param value  ååæ ¼å¼
     * @param column åå¯¹è±¡
     * @todo æ°å­æ ¼å¼åè¿ä¸å®å  è¿ä¸ªåªæ¯éé¢å½¢å¼çæ ¼å¼å;   åå§åvalue===nullæ¶,åºè¯¥æ¾ç¤ºä¸º'' è¿ä¸ªè¿æ²¡æ
     */
    private getFormatNumber(value: any, column: any) {
        let precision;
        if (column && column.format) {
            precision = parseInt(column.format.substr(1), 10);
        } else if (column && column.editor) {
            precision = column.editor.precision;
        }
        if (isNaN(precision)) {
            precision = 2;
        }
        if (!value && value !== 0) {
            return '';
        }

        const opts = {
            prefix: column.prefix ? column.prefix : '',
            suffix: column.suffix ? column.suffix : '',
            precision: precision,
            thousand: ',',
            stripZeros: false,
        };
        return this.numberService.formatMoney(value, opts);
    }

    /**
     * å¤è¡ææ¬æ ¼å¼å shift+enteræ¢è¡  å¤±å»ç¦ç¹ä¿çåæ ¼å¼
     * @param value  ååæ ¼å¼
     * @param column åå¯¹è±¡
     */
    private getMultiText(value: any, column: any) {
        let strValue = value;
        if (strValue !== '' && !strValue) {
            strValue = '';
        }
        if (typeof strValue !== 'string') {
            const valueType = typeof strValue;
            throw new Error(`${valueType}ç±»åå¼ä¸åæ³ï¼æ æ³è¿è¡æ ¼å¼å`);
        }
        // é²æ­¢xss
        strValue = strValue.replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/\"/g, '&quot;')
            .replace(/\'/g, '&#39;')
            .replace(/\//g, '&#x2F;');
        // å¦ææ¯å¤è¡ææ¬æ¡  ä¿çæ ¼å¼
        if (column.editor && column.editor.type === 'MultiTextBox') {
            const INDEX = strValue.indexOf('\n');
            if (INDEX > -1) {
                return strValue.replace(/\n/g, '<br>');
            }
            return strValue;
        }
        // è¥ä¸ºstring
        return strValue;
    }
}
export { FarrisKendoGridFormatService };
